module.exports = __webpack_public_path__ + "img/guru.b06da1fe.jpg";